// Generated by purs version 0.15.15
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ratio from "../Data.Ratio/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var reduce = /* #__PURE__ */ Data_Ratio.reduce(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var denominatorIsSymbol = {
    reflectSymbol: function () {
        return "denominator";
    }
};
var numeratorIsSymbol = {
    reflectSymbol: function () {
        return "numerator";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode);
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(numeratorIsSymbol)(encodeWithOptionsOther))(denominatorIsSymbol)(encodeWithOptionsOther)));
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode);
var Rational = function (x) {
    return x;
};
var toRationalInt = {
    toRational: function (a) {
        return function (b) {
            return reduce(a)(b);
        };
    }
};
var toRational = function (dict) {
    return dict.toRational;
};
var toRational1 = /* #__PURE__ */ toRational(toRationalInt);
var udecodeRational = {
    unsafeDecode: /* #__PURE__ */ (function () {
        var dec = function (v) {
            return toRational1(v.numerator)(v.denominator);
        };
        var $69 = Unscramble.unsafeDecode(Unscramble.decodeRecord1()(Unscramble.decodeRecordCons(denominatorIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(numeratorIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))));
        return function ($70) {
            return dec($69($70));
        };
    })()
};
var toNumerator = function (v) {
    return Data_Ratio.numerator(v);
};
var toDenominator = function (v) {
    return Data_Ratio.denominator(v);
};
var showRational = /* #__PURE__ */ Data_Ratio.showRatio(Data_Show.showInt);
var semiringRational = /* #__PURE__ */ Data_Ratio.semiringRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var ringRational = /* #__PURE__ */ Data_Ratio.ringRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var ordRational = /* #__PURE__ */ Data_Ratio.ordRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var newtypeRational = {
    Coercible0: function () {
        return undefined;
    }
};
var fromInt = function (i) {
    return reduce(i)(1);
};
var euclideanRingRational = /* #__PURE__ */ Data_Ratio.euclideanRingRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var eqRational = /* #__PURE__ */ Data_Ratio.eqRatio(Data_Eq.eqInt);
var encodeRational = {
    encode: function (r) {
        return encode({
            numerator: toNumerator(r),
            denominator: toDenominator(r)
        });
    }
};
var divisionRingRational = /* #__PURE__ */ Data_Ratio.divisionRingRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var decodeRational = {
    decode: /* #__PURE__ */ (function () {
        var dec = function (v) {
            return reduce(v.numerator)(v.denominator);
        };
        var $71 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(dec);
        var $72 = Foreign_Generic_Class.decode(Foreign_Generic_Class.recordDecode()(decodeRecordCons(decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(numeratorIsSymbol)(decodeWithOptionsOther)())(denominatorIsSymbol)(decodeWithOptionsOther)()));
        return function ($73) {
            return $71($72($73));
        };
    })()
};
var commutativeRingRational = /* #__PURE__ */ Data_Ratio.commutativeRingRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
export {
    Rational,
    toNumerator,
    toDenominator,
    toRational,
    fromInt,
    toRationalInt,
    newtypeRational,
    eqRational,
    ordRational,
    showRational,
    semiringRational,
    ringRational,
    commutativeRingRational,
    euclideanRingRational,
    divisionRingRational,
    encodeRational,
    decodeRational,
    udecodeRational
};
